import axios from "../httpHandler";

export const getProducts = async () => {
  try {
    const result = await axios.get(`input`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getUnits = async () => {
  try {
    const result = await axios.get(`unit`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getProvinces = async () => {
  try {
    const result = await axios.get(`province`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getProvinceCities = async ({id}) => {
  try {
    const result = await axios.get(`province/${id}/cities`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getIngredients = async () => {
  try {
    const result = await axios.get(`ingredient`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getUnions = async () => {
  try {
    const result = await axios.get(`union`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createProduct = async (data) => {
  return axios.post(`input`, {
    ...data,
  });
};

export const createUnit = async (data) => {
  return axios.post(`unit`, {
    ...data,
    amount: parseFloat((data?.amount ?? '0').replaceAll(',', '')),
  });
};

export const createIngredient = async (data) => {
  return axios.post(`ingredient`, {
    ...data,
  });
};

export const createUnion = async (data) => {
  return axios.post(`union`, {
    ...data,
  });
};
export const deleteProduct = async ({id}) => {
  return axios.delete(`input/${id}`);
};

export const deleteUnit = async ({ id }) => {
  return axios.delete(`unit/${id}`);
};

export const deleteIngredient = async ({id}) => {
  return axios.delete(`ingredient/${id}`);
};

export const deleteUnion = async ({id}) => {
  return axios.delete(`union/${id}`);
};

export const updateProduct = (data) => {
  return axios.put(`input/${data?.id}`, {
    ...data,
  });
};

export const updateUnit = (data) => {
  return axios.put(`unit/${data?.id}`, {
    ...data,
  });
};

export const updateIngredient = (data) => {
  return axios.put(`ingredient/${data?.id}`, {
    ...data,
  });
};

export const updateUnion = (data) => {
  return axios.put(`union/${data?.id}`, {
    ...data,
  });
};